// extracted by css-extract-rspack-plugin
export default {"cls1":"SignupBanner-cls1_aOi","cls2":"SignupBanner-cls2_4zX SignupBanner-cls1_aOi"};